import { connectivityInitialState, ConnectivityState } from '../connectivity/connectivity.store';
import { environmentInitialState, EnvironmentState } from '../environment/environment.state';
import { pdfModalInitialState, PdfModalState } from '../pdf-modal/redux/pdf-modal.state';
import { seReportInitialState, SeReportState } from '../report/report.state';
import { externalDocsInitialState, ExternalDocsState } from '../se-external-docs/redux/external-docs.state';
import { seSideNavComponentInitialState, SeSideNavState } from '../se-side/redux/se-side-nav.state';
import { seStepperSideNavParentInitialState, SeStepperSideNavParentState } from "../se-stepper-side-nav/redux/se-stepper-side-nav.state";
import { seTimelineInitialState, SeTimelineState } from "../se-timeline/redux/se-timeline.state";
import {
    seButtonsToolbarInitialState,
    SeButtonsToolbarState,
} from '../se-toolbar/se-buttons-toolbar/redux/se-buttons-toolbar.state';
import {
    HeaderToolbarState,
    seHeaderToolbarInitialState,
} from '../se-toolbar/se-header-toolbar/se-header-toolbar.state';
import { tooluploadInitialState, TooluploadState } from '../se-toolupload/redux/toolupload.state';
import { searchPageInitialState, SearchPageState } from '../search-page/redux/search-page.state';
import { seSignInitialState, SeSignState } from '../sign/estensasign.state';

export interface RootState {
    buttonsToolbar: SeButtonsToolbarState;
    connectivity: ConnectivityState;
    environment: EnvironmentState;
    externalDocs: ExternalDocsState;
    headerToolbar: HeaderToolbarState;
    pdfModal: PdfModalState;
    report: SeReportState;
    searchPage: SearchPageState;
    seSideNav: SeSideNavState;
    sign: SeSignState;
    toolVna: TooluploadState;
    seStepperSideNav : SeStepperSideNavParentState;
    seTimeline: SeTimelineState;
}

export const initialRootState: RootState = {
    buttonsToolbar: seButtonsToolbarInitialState,
    connectivity: connectivityInitialState,
    environment: environmentInitialState,
    externalDocs: externalDocsInitialState,
    headerToolbar: seHeaderToolbarInitialState,
    report: seReportInitialState,
    pdfModal: pdfModalInitialState,
    searchPage: searchPageInitialState,
    seSideNav: seSideNavComponentInitialState,
    sign: seSignInitialState,
    toolVna: tooluploadInitialState,
    seStepperSideNav: seStepperSideNavParentInitialState,
    seTimeline: seTimelineInitialState
};
